import type { VerificationState } from '../ns-elements/verification-factors.js';

// What a person's verification badge shows. Verified (green) once Companies House or HMRC verified them, or colleagues verified
// every claim they made (`verified`, set by the add-company lambdas and company/verify-staff-claims); a claim still under
// review (director, payment approver or who they report to) is the process started but not finished (amber); anything else is
// not verified yet (red). Pure, so the unit tests import it directly.
export interface VerificationPerson {
  verified?: boolean | null;
  director?: string | null;
  paymentApprover?: string | null;
  reportsTo?: ReadonlyArray<{ verificationStatus?: string | null }> | null;
}

export function personVerificationState(person: VerificationPerson | null | undefined): VerificationState {
  if (!person) return 'invalid';
  if (person.verified === true) return 'verified';
  const underReview =
    person.director === 'UNDER_REVIEW' ||
    person.paymentApprover === 'UNDER_REVIEW' ||
    (person.reportsTo ?? []).some((manager) => manager?.verificationStatus === 'UNDER_REVIEW');
  return underReview ? 'warning' : 'invalid';
}
